import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class ModalController extends Controller {
  static targets = ['modal']

  constructor (context) {
    super(context)
    this.modal = new Modal(this.modalTarget)
  }

  openModal () {
    this.modal.show()
  }

  closeModal () {
    this.modal.hide()
  }
}
